import React, { useEffect, useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import liracrypt from "../Liracrypt/liracrypt";
import { Spin, Form, Select, Card } from "antd";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import LineAttendance from "../../pages/LineAttendance";

const AccessDropDown = ({ setPageHeader }) => {
  setPageHeader("Line Attendance");
  const [selectedLid, setSelectedLid] = useState(null);
  const [loadLineAccess, setLoadLineAccess] = useState(null);
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const [loginError, setLoginError] = useState(false);
  const [selectedName, setSelectedName] = useState(null);

  const [notContent, setNotContent] = useState(false);

  const fetchLineAccess = () => {
    liracrypt
      .get("/attendance/scan/access", {})
      .then((res, req) => {
        if (res.status === 204) {
          setNotContent(true);
        } else {
          if (res.data.data.length === 1) {
            
            setSelectedLid(res.data.data[0]["_id"]);
            setSelectedName(res.data.data[0]["lame"]);
          } else {
            setLoadLineAccess(res.data.data);
          }
        }
      })
      .catch(function (error) {
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  useEffect(() => {
    if (loadLineAccess === null) {
      fetchLineAccess();
    }
  }, [loadLineAccess]);

  const getKeyByValue = (object, value) => {
    return object.forEach((obj) => {
      if (obj._id == value) {
        let v = obj.lame ? obj.lame : obj.dame;
        
        setSelectedName(v);
      }
    });
  };

  return (
    <>
      <SessionError visible={loginError} />
      <React.Fragment>
        {selectedLid && selectedName ? (
          <>
            <LineAttendance lid={selectedLid} selectedName={selectedName} />
          </>
        ) : (
          <div
            className="dash"
            style={{
              backgroundColor: "#222",
              height: "90vh",
              margin: "10px",
              border: 0,
              boxShadow: "5px 5px 10px #1f1f1f, -5px -5px 10px #2d2d2d",
              borderRadius: "10px",
              fontWeight: "600",
              overflow: "hidden",
            }}
          >
            <Card
              title="Please select a line"
              bordered={false}
              style={{
                margin: "10% auto",
                backgroundColor: "#424358",
                maxWidth: "600px",
              }}
            >
              {loadLineAccess ? (
                <>
                  {notContent ? (
                    <>
                      <h3 style={{ color: "#fff" }}>
                        Not Authorized to Access Linedashboard
                      </h3>
                    </>
                  ) : (
                    <Form.Item
                      className="selectLine"
                      // label="Line"
                      rules={[{ required: true, message: "Select a line" }]}
                    >
                      <Select
                        showSearch
                        style={{ width: 200 }}
                        placeholder="Select a line"
                        optionFilterProp="children"
                        onChange={(value) => {
                          getKeyByValue(loadLineAccess, value);
                          setSelectedLid(value);
                        }}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {loadLineAccess.map((obj) => (
                          <Select.Option value={obj._id}>
                            {obj.lame ? obj.lame : obj.dame}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  )}
                </>
              ) : (
                <div className="Loading">
                  <Spin indicator={antIcon} />
                </div>
              )}
            </Card>
          </div>
        )}
      </React.Fragment>
    </>
  );
};
export default AccessDropDown;
